import CreateAnimatedLP from "@/components/MarketingPage/CreateAnimatedLP";
import { FooterDataType } from "@/components/organisms/Footer";
import {
  ROOT_HOST
} from "@/shared/constants/env/internalService.constants";
import { footerData_en, footerData_us } from "@/shared/data/footer.data";
import { footerData_kr } from "@/shared/data/footer.data.kr";
import { NavbarDataType, navbarData_en, navbarData_us } from "@/shared/data/navbar.data";
import { navbarData_kr } from "@/shared/data/navbar.data.kr";
import axios from "axios";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";

type GetStartedProps = {
  pageName: string;
  pageData: {
    data: string;
    meta: string;
  };
  langFile: string;
  navbarData: NavbarDataType;
  footerData: FooterDataType;
};

const GetStarted = ({
  pageName,
  pageData,
  langFile,
  navbarData,
  footerData,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <>
      <CreateAnimatedLP
        pageSections={pageData.data}
        meta={pageData.meta}
        scheduleDemoOnly
        langFile={langFile}
        topSubscribedGraphers={[]}
        options={undefined}
        navbarData={navbarData}
        footerData={footerData}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<GetStartedProps> = async (
  context
) => {
  const pageName = "get-started-test";
  const locale = context.locale;
  const defaultLocale = context.defaultLocale;
  const isDefaultLocale = locale === defaultLocale;
  const localePageName = isDefaultLocale ? pageName : `${pageName}.${locale}`;

  const urls = [
    `${ROOT_HOST}/api/marketing/?page=${localePageName}`,
    `${ROOT_HOST}/api/marketing/?page=${pageName}`,
  ];

  let pageData = null;

  for (const url of urls) {
    try {
      const response = await axios.get(url);

      if (response?.data?.data) {
        pageData = response.data.data;
        break;
      }
    } catch (error) {
      // Continue to the next URL
    }
  }

  const navbarData = {
    en: navbarData_en,
    us: navbarData_us,
    kr: navbarData_kr,
    in: navbarData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const footerData = {
    en: footerData_en,
    us: footerData_us,
    kr: footerData_kr,
    in: footerData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  if (pageData) {
    return {
      props: {
        pageName,
        pageData: pageData,
        langFile: context?.locale !== "en" ? pageName : "",
        navbarData,
        footerData,
        // ...(await serverSideTranslations(context?.locale, [pageName, "common"])),
      },
    };
  } else {
    console.error(`[get-started] Page data not found for ${pageName}`);
    return {
      notFound: true,
    };
  }
};

export default GetStarted;
